import useToast from '@hooks/useToast'
import { Chip, Stack, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import React, { FC } from 'react'

const Toast: FC = () => {
  const { visible, message } = useToast()

  return (
    <Stack
      component={motion.div}
      initial={{ opacity: 0, y: 40 }}
      animate={{
        opacity: visible ? 1 : 0,
        y: visible ? 0 : 40,
      }}
      transition={{ duration: 0.3 }}
      position="fixed"
      bottom={20}
      alignSelf="center"
    >
      <Stack bgcolor="white" py={1} px={2} borderRadius={2}>
        <Typography textAlign="center" color={(theme) => theme.palette.background.default}>
          {message}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default Toast
